import BlankView from '@/components/BlankView.vue'
const systemManagement = [
      {
        path: 'systemManagement',
        name: '系统管理',
        component: BlankView,
        children:[
           //用户管理
          {
            path: 'userManagement',
            name: 'userManagement',
            component: () => import('@/views/systemManagement/userManagement.vue'),
          },
          //角色管理
          {
            path: 'roleManagement',
            name: 'roleManagement',
            component: () => import('@/views/systemManagement/roleManagement.vue'),
          },
          //权限管理
          {
            path: 'authorityManagement',
            name: 'authorityManagement',
            component: () => import('@/views/systemManagement/authorityManagement.vue'),
          },
          //操作日志
          {
            path: 'logManagement',
            name: 'logManagement',
            component: () => import('@/views/systemManagement/logManagement.vue'),
          }
        ]
      }
    
];


export default systemManagement;